import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';

const Figure = styled.figure`
  margin: 0;
  display: flex;

  /* stylelint-disable-next-line selector-type-no-unknown */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    display: none;
  }
`;

const heroPropertyTypes = {
  image: PropTypes.node,
  className: PropTypes.string,
};

type HeroProperties = InferProps<typeof heroPropertyTypes>;

const Hero = ({
  image,
  className,
}: HeroProperties) => (
  <Figure className={className ?? undefined}>
    {image}
  </Figure>
);

Hero.propTypes = heroPropertyTypes;

export default Hero;
